@if (notice$ | async; as notice) {
<div class="flex items-start gap-3 bg-amber-50 border-b border-amber-300 text-amber-900 px-5 py-3">
  <i class="pi pi-exclamation-triangle mt-0.5"></i>
  <div class="flex-1 text-sm">
    <p class="font-semibold">{{ 'SYSTEM_MAINTENANCE.BANNER.TITLE' | translate }}</p>
    <p>{{ 'SYSTEM_MAINTENANCE.BANNER.MESSAGE' | translate: { start: notice.start, end: notice.end } }}</p>
  </div>
  <button
    type="button"
    class="pi pi-times cursor-pointer text-amber-700 hover:text-amber-900"
    [attr.aria-label]="'SYSTEM_MAINTENANCE.BANNER.CLOSE' | translate"
    (click)="onClose()"></button>
</div>
}
